/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/components/feedback',['require','core/templates','modules/components/text-panel'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var templates = require('core/templates');
  var TextPanel = require('modules/components/text-panel');

  /*****************************************************************************************************************///}

  var Feedback = TextPanel.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    template: templates['modules/components/feedback'],
    className: 'feedback-panel',

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      TextPanel.prototype.initialize.apply(this, arguments);
    }

  /*****************************************************************************************************************///}

  });

  return Feedback;

});

